module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("DREAMS and VISIONS")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txc7",
    attrs: {
      "id": "p0010-02-1"
    }
  }, [_c('span', [_c('i', [_vm._v("I revealed myself "), _c('br'), _vm._v("to those who did not ask for me; "), _c('br'), _vm._v("I was found "), _c('br'), _vm._v("by those who did not seek me.")]), _c('br'), _vm._v("                                    —I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SAIAH 65:1 ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbe32110","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 69
// module chunks = 0